import {
  getAccountsInfo, getAccountSlotUrl, getFirstLoggedInAccountSlot,
} from '../../../util/multiaccount';

export function navigateBack() {
  const currentUrl = new URL(window.location.href);
  const referrer = document.referrer ? new URL(document.referrer) : undefined;

  if (referrer?.origin === currentUrl.origin
    && referrer.pathname === currentUrl.pathname
    && referrer.searchParams.get('account') !== currentUrl.searchParams.get('account')) {
    window.location.assign(referrer.toString());
    return;
  }

  const accounts = getAccountsInfo();
  const firstSlot = getFirstLoggedInAccountSlot(accounts) || 1;
  window.location.href = getAccountSlotUrl(firstSlot, false, accounts[firstSlot]?.isTest);
}
